import React from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import ButtonsCell from '../../../../Common/CustomGridCells/ButtonsCell/buttonsCell';
import LinkCell from '../../../../Common/CustomGridCells/LinkCell/linkCell';
import GridHelper from 'infrastructure/js/components/Grid/Utils/gridHelper';
import {dialogsNames} from '../../../../../enums/dialogsNames';
import {qplAcceptanceDecisionTypes} from '../../../../../enums/qplAcceptanceDecisionTypes';

import './qplsPendingRequestsViewGrid.scss';

class QplsPendingRequestsViewGrid extends React.PureComponent {

  filterConfig = [
    {fieldName: 'requestTimestamp.epochDateTime', filterName: 'requestTimestamp'},
  ];

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.pendingRequests.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'requestTimestamp.epochDateTime',
        title: this.labels.get('columns.time.title'),
        filterType: filterTypes.NONE, //filterTypes.DATE_SELECT,
        valueFormatter: (params) => {
          return (params.data && params.data.m_Time ? params.data.m_Time : '');
        },
        width: 165,
        columnOptions: {
          cellRenderer: 'agGroupCellRenderer',
          sort: 'desc',
          headerComponentParams: GridHelper.getDateFormatHeaderIcon(),
          valueGetter: (params) => {
            return params.data?.requestTimestamp?.epochDateTime;
          },
        }
      },
      {
        fieldName: 'lotName',
        title: this.labels.get('columns.lot.title'),
        filterType: filterTypes.NONE,
        filterName: 'lot',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'qplName',
        title: this.labels.get('columns.qplName.title'),
        filterType: filterTypes.NONE,
        filterName: 'name',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'qplVersion',
        title: this.labels.get('columns.qplVersion.title'),
        filterType: filterTypes.NONE,
        filterName: 'versionName',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'testName',
        title: this.labels.get('columns.testName.title'),
        filterType: filterTypes.NONE,
        filterName: 'testName',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'setName',
        title: this.labels.get('columns.setName.title'),
        filterType: filterTypes.NONE,
        filterName: 'setName',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'setId',
        title: this.labels.get('columns.setDetails.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LinkCell,
          valueGetter: (params) => {
            return {
              label: this.labels.get('columns.setDetails.cell.viewDetails'),
              onClickHandler: () => {
                this.props.exportCoCTestSetDetailsToPdf(params.data.setId);
              }
            };
          }
        }
      },
      {
        fieldName: 'requestComment',
        title: this.labels.get('columns.requestComment.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'decision',
        title: this.labels.get('columns.decision.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: ButtonsCell,
          valueGetter: (params) => {
            return [
              {
                id: 'acceptBtn',
                label: this.labels.get('columns.decision.button.accept'),
                className: 'accept-btn',
                onClickHandler: () => {
                  this.props.showAcceptanceDecisionDialog({
                    activeDialog: dialogsNames.QPL_ACCEPTANCE_DECISION_DIALOG,
                    dialogData: {...params.data, decision: qplAcceptanceDecisionTypes.ACCEPTED},
                  });
                },
              },
              {
                id: 'declineBtn',
                label: this.labels.get('columns.decision.button.decline'),
                className: 'decline-btn',
                onClickHandler: () => {
                  this.props.showAcceptanceDecisionDialog({
                    activeDialog: dialogsNames.QPL_ACCEPTANCE_DECISION_DIALOG,
                    dialogData: {...params.data, decision: qplAcceptanceDecisionTypes.DECLINED},
                  });
                },
              },
            ];
          },
        },
      },
    ]
  };

  render() {
    return (
      <div className="administration-view-grid qpls-pending-requests-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_PENDING_REQUESTS}
              columnsConfig={this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={
                {
                  checkboxSelection: false,
                }
              }
        >
        </Grid>
      </div>
    );
  }
}

QplsPendingRequestsViewGrid.propTypes = {
  actions: PropTypes.object.isRequired,
  exportCoCTestSetDetailsToPdf: PropTypes.func.isRequired,
  showAcceptanceDecisionDialog: PropTypes.func.isRequired,
};

export default reduxForm({
    form: 'qplsPendingRequestsiewGrid'
  }
)(QplsPendingRequestsViewGrid);
